<template>
  <div>
    <div class="mrB20" />
    <sui-grid
      ref="grid"
      :columns="gridColumns0"
      :dataset="'dsRuleParam'"
      :showDisplayCountControl="false"
      :multiselect="true"
    >
      <div class="comp_spacing" />
      <div class="btn_wrapL">
        <sui-button
          v-permission:delete="pageId"
          type="button"
          class="comm_btn_gridTop"
          @click="onClickRowDelete"
        >
          {{ $t('MSG_BTN_ROW_DEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_gridTop"
          @click="onClickCancel"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
      </div>
    </sui-grid>
    <div class="comm_btn_wrap">
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001_T04', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    ruleUid: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
    actionMappingList: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      inBoundDVOList: [],
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PRMT_ID'),
        datafield: 'paramId',
      }, {
        text: this.$t('MSG_TXT_PRMT_NM'),
        datafield: 'paramItemName',
      }, {
        text: this.$t('MSG_TXT_IN_DVO'),
        datafield: 'dvoName',
        createwidget: (row, column, value, htmlElement) => {
          const componentInstance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement,
            {
              optionList: this.inBoundDVOList,
            },
            this.dsRuleParam, this.$refs.grid);

          componentInstance.getComponentInstance().$on('select', event => {
            const rowIndex = componentInstance.getDatasetIndex();
            this.dvoSelectChange(rowIndex, event);
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRMT_MAPPING_VAL'),
        datafield: 'paramMappingValue',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
              maxlength: 50,
              checkDisabledFunction: this.checkDisabledFunction,
            },
            this.dsRuleParam, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsRuleParam, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
    };
  },
  computed: {},
  watch: {
    ruleUid() {
      if (!utils.isEmpty(this.ruleUid)) {
        this.setInboundDVOList();
      }
    },
  },
  activated() {
    if (!utils.isEmpty(this.ruleUid)) {
      this.setInboundDVOList();
    }
  },
  datasets: [{
    id: 'dsRuleParam',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'ruleParamMappingUid', map: 'ruleParamMappingUid' },
      { type: 'string', name: 'paramItemName', map: 'paramItemName' },
      { type: 'string', name: 'paramId', map: 'paramId' },
      { type: 'string', name: 'ruleUid', map: 'ruleUid' },
      { type: 'string', name: 'dvoName', map: 'dvoName' },
      { type: 'string', name: 'paramMappingValue', map: 'paramMappingValue' },
      { type: 'string', name: 'loginId', map: 'loginId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' }],
  }],
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.ruleUid)) {
        this.setInboundDVOList();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * InboundDVO selectBox 목록 조회
     */
    setInboundDVOList() {
      http.request(this.pageId, 'DTS_CMR_00010', {
        path: {
          'data-service-id': this.selectedRowData.dataServiceId,
        },
      }).then(res => {
        const inBoundDVOList = [];
        this.inBoundDVOList = [];

        utils.forEach(res.data, obj => {
          const option = {
            key: obj.code,
            label: obj.displayName,
          };
          inBoundDVOList.push(option);
        });
        this.inBoundDVOList = inBoundDVOList;

        this.setRuleParamData(); // selectBox 목록 조회 후 데이터 조회.
      });
    },
    /**
     * Rule 파라미터 목록 조회
     */
    setRuleParamData() {
      http.request(this.pageId, 'DTS_CMR_00013', {
        path: {
          'rule-uid': this.ruleUid,
        },
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM']);
        this.dsRuleParam.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * InboundDVO SelectBox Change Event.
     */
    dvoSelectChange(rowIndex, event) {
      if (utils.startsWith(event, 'entity')) {
        this.dsRuleParam.setData(rowIndex, 'paramMappingValue', event);
      } else if (utils.startsWith(event, 'ResponseSize')) {
        this.dsRuleParam.setData(rowIndex, 'paramMappingValue', 'size');
      } else {
        this.dsRuleParam.setData(rowIndex, 'paramMappingValue', '');
      }
    },
    /**
     * InboundDVO 값에 따라 파라미터 매핑 값 입력 제한.
     */
    paramMappingValueDisabled(rowIndex) {
      const { dvoName } = this.dsRuleParam.data[rowIndex];
      if (utils.isEmpty(dvoName)) return false;
      if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
    /**
     * Grid Row Button
     */
    onClickCancel() {
      this.dsRuleParam.setRawData(this.dsRuleParam.originalData);
    },
    onClickRowDelete() {
      const selectedIndexes = this.dsRuleParam.getSelectedIndexes();
      this.dsRuleParam.deleteRows(selectedIndexes);
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = this.rowState();

      if (!this.selectedRowCheck()) return false;
      if (!this.validationCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00041', {
          path: {
            'rule-uid': this.ruleUid,
          },
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.dsRuleParam.submit(); // 해당 dataset CRUD 정보 리셋
          this.setRuleParamData();
        });
      });

      return true;
    },
    /**
     * Grid CRUD List 추출.
     */
    rowState() {
      const insertRuleParamList = this.dsRuleParam.data;
      const updateRuleParamList = [];
      const deleteRuleParamList = [];

      utils.forEach(this.dsRuleParam.rowStateMap, (key, value) => {
        let index = -1;
        switch (key) {
          case 'D':
            index = utils.findIndex(this.dsRuleParam.originalData, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) deleteRuleParamList.push(this.dsRuleParam.originalData[index]);
            break;
          case 'U':
            index = utils.findIndex(this.dsRuleParam.data, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) updateRuleParamList.push(this.dsRuleParam.data[index]);
            break;
          default:
            break;
        }
      });
      return {
        insertRuleParamList,
        updateRuleParamList,
        deleteRuleParamList,
      };
    },
    /**
     * null Check
     */
    validationCheck() {
      let flag = true;

      utils.forEach(this.dsRuleParam.data, (obj, row) => {
        if (utils.isEmpty(obj.dvoName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_IN_DVO')),
          null,
          () => {
            this.gridSetFocus(row, 'dvoName');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.paramMappingValue)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRMT_MAPPING_VAL')),
          null,
          () => {
            this.gridSetFocus(row, 'paramMappingValue');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    selectedRowCheck() {
      if (utils.isEmpty(utils.trim(this.ruleUid))) {
        utils.messageBox('warning', this.$t('MSG_ALT_RUL_NOT_INFO'));
        return false;
      }
      return true;
    },
    /**
     * grid disabled Function
     */
    checkDisabledFunction(rowData) {
      const { dvoName } = rowData;
      if (utils.isEmpty(dvoName)) {
        return false;
      } if (utils.startsWith(dvoName, 'entity') || utils.startsWith(dvoName, 'ResponseSize')) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
